// NPM
import { defineStore } from 'pinia';

// Services
import Api from '@/services/api';

// Stores
import { useUserStore } from '@/stores/user';
import type {
  UserDashboardGetAllUgcsResponseType,
  UserDashboardStartUgcResponseType,
} from '@magma-app/magma-types/all';

export const useUgcsStore = defineStore('ugcs', {
  state: () => {
    return {
      availableUgcs: [] as UserDashboardGetAllUgcsResponseType['available'],
      completedUgcs: [] as UserDashboardGetAllUgcsResponseType['validated'],
      uncompletedUgcs: [] as UserDashboardGetAllUgcsResponseType['ongoing'],
      displayCompletedUgcDetails: false,
      displayUgcDetails: false,
    };
  },

  actions: {
    setCompletedUgcDetails(displayCompletedUgcDetails: boolean) {
      this.displayCompletedUgcDetails = displayCompletedUgcDetails;
    },

    setUgcDetails(displayUgcDetails: boolean) {
      this.displayUgcDetails = displayUgcDetails;
    },

    async getUgcs() {
      const response = await Api.userDashboard().ugcs.getUgcs();

      this.completedUgcs = response.data.validated;
      this.uncompletedUgcs = response.data.ongoing;
      this.availableUgcs = response.data.available;
    },

    async accomplishUgc(userUgcId: number) {
      const response = await Api.userDashboard().ugcs.accomplishUgc({
        userUgcId,
      });

      const ugcIndex = this.uncompletedUgcs.findIndex((ugc) => {
        return ugc.userUgcId === userUgcId;
      });

      this.uncompletedUgcs.splice(ugcIndex, 1);
      this.completedUgcs.push(response.data);

      if (response.data.status === 'validated') {
        const userStore = useUserStore();
        const userBalance =
          (userStore.user?.balance || 0) + response.data.points;
        userStore.updateUserBalance(userBalance);
      }
    },

    async startUgc(ugcId: number) {
      const response = await Api.userDashboard().ugcs.startUgc({ ugcId });

      const ugcIndex = this.availableUgcs.findIndex((ugc) => {
        return ugc.ugcId === ugcId;
      });

      this.availableUgcs.splice(ugcIndex, 1);
      this.uncompletedUgcs.push(
        response.data as UserDashboardStartUgcResponseType
      );
    },
  },
});
